"use strict";
/**
 * PayrollV2 Types — unified PayrollItem-based model.
 *
 * Each item is self-describing: carries SAT codes, taxed/exempt split,
 * source key for internal reference, and an optional formula explaining
 * how the amount was calculated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollItemCategory = void 0;
// ============================================================
// Core item types
// ============================================================
var PayrollItemCategory;
(function (PayrollItemCategory) {
    PayrollItemCategory["BASE_SALARY"] = "BASE_SALARY";
    PayrollItemCategory["ADDITIONAL_FIXED"] = "ADDITIONAL_FIXED";
    PayrollItemCategory["COMMISSION"] = "COMMISSION";
    PayrollItemCategory["BONUS"] = "BONUS";
    PayrollItemCategory["OVERTIME"] = "OVERTIME";
    PayrollItemCategory["HOLIDAY_PAY"] = "HOLIDAY_PAY";
    PayrollItemCategory["YEAR_END_BONUS"] = "YEAR_END_BONUS";
    PayrollItemCategory["VACATION_PAY"] = "VACATION_PAY";
    PayrollItemCategory["VACATION_BONUS"] = "VACATION_BONUS";
    PayrollItemCategory["PROFIT_SHARING"] = "PROFIT_SHARING";
    PayrollItemCategory["SUBSIDY"] = "SUBSIDY";
    PayrollItemCategory["SUPPORT"] = "SUPPORT";
    PayrollItemCategory["COMPENSATION"] = "COMPENSATION";
    PayrollItemCategory["TAX"] = "TAX";
    PayrollItemCategory["SOCIAL_SECURITY"] = "SOCIAL_SECURITY";
    PayrollItemCategory["ATTENDANCE_DISCOUNT"] = "ATTENDANCE_DISCOUNT";
    PayrollItemCategory["OTHER_DEDUCTION"] = "OTHER_DEDUCTION";
    PayrollItemCategory["OTHER_PAYMENT"] = "OTHER_PAYMENT";
})(PayrollItemCategory || (exports.PayrollItemCategory = PayrollItemCategory = {}));
